import { useState, useEffect} from 'react'
import '../styles/WcagContrastRatio.css'
import useContrastRatio from '../hooks/useContrastRatio'
import info from '../assets/info.svg'

const WcagContrastRatio = () => {
  const [backgroundColor, setbackgroundColor] = useState("#2b2d31")
  const [textColor, setTextColor] = useState("#eaeaeb")
  const [wcagRatio, setWcagRatio] = useState(10.5)
  const [wcagColor, setWcagColor] = useState("#1c731d")
  const rawRatio = useContrastRatio(backgroundColor, textColor)

  useEffect(() => {
    const calculatedRatio = rawRatio[0] / rawRatio[1]
    setWcagRatio(Number(calculatedRatio.toFixed(1)))
    setWcagColor(calculatedRatio < 4.5 ? "#c1253c" : "#1c731d");
  }, [rawRatio])

  return (
    <div className='wcag-contrast-page'>
      <section className='color-picker-section'>
        <div className='background-color-div'>
          <label htmlFor="background">Background color: </label>
          <input 
            type="color" 
            name="background-color-picker" 
            id="background-color-picker" 
            value={backgroundColor} 
            onChange={(e) => setbackgroundColor(e.target.value)} 
            onInput={(e) => setbackgroundColor(e.target.value)}
          />
        </div>
        <div className='text-color-div'>
          <label htmlFor="text-color">Text color: </label>
          <input 
            type="color" 
            name="text-color-picker" 
            id="text-color-picker" 
            value={textColor} 
            onChange={(e) => setTextColor(e.target.value)}
            onInput={(e) => setTextColor(e.target.value)}
          />
        </div>
      </section>
      <section className="display-preview">
        <div className='background-div' style={{backgroundColor: backgroundColor}}>
          <p className='text-div' style={{color: textColor}}>Dummy Text</p>
        </div>
      </section>
      <div className="wcag-ratio-div" style={{backgroundColor: wcagColor}}>{wcagRatio}: 1 {(backgroundColor !== "#424242") && (wcagRatio > 4.5 ? " - Passes WCAG Test!" : " - Failed WCAG Test :(")}</div>
      <a
        href="https://www.google.com/search?q=WCAG+contrast+ratio"
        target="_blank"
        rel="noopener noreferrer"
        className='learn-wcag-google'
      >
        <img src={info} alt="info_icon" />
        <p>Learn about WCAG Contrast Ratio</p>
      </a>

    </div>
  )
}

export default WcagContrastRatio